import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Operator from '../views/Operator.vue'
import Overview from '../views/Overview.vue'
import ItemGroups from '../views/ItemGroups.vue'
import SideOrders from '../views/SideOrders.vue'
import XReport from '../views/XReport.vue'
import ZReport from '../views/ZReport.vue'
import DetailedReport from '../views/DetailedReport.vue'
import Payments from '../views/Payments.vue'
import BarviewAccess from '../views/BarviewAccess.vue'
import Messages from '../views/Messages.vue'
import PublicBooking from '../views/PublicBooking.vue'
import PublicCancel from '../views/PublicCancel.vue'
import Categories from '../views/Categories.vue'
import Auditlog from '../views/Auditlog.vue'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'home'}
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/operator/:id',
      name: 'operator',
      component: Operator,
      props: true
    },
    {
      path: '/overview',
      name: 'overview',
      component: Overview
    },
    {
      path: '/itemgroups',
      name: 'itemgroups',
      component: ItemGroups
    },
    {
      path: '/sideorders',
      name: 'sideorders',
      component: SideOrders
    },
    {
      path: '/categories',
      name: 'categories',
      component: Categories
    },
    {
      path: '/report/z',
      name: 'zreport',
      component: ZReport
    },
    {
      path: '/report/x',
      name: 'xreport',
      component: XReport
    },
    {
      path: '/report/detailed',
      name: 'detailedreport',
      component: DetailedReport
    },
    {
      path: '/payments',
      name: 'payments',
      component: Payments
    },
    {
      path: '/barviewaccess',
      name: 'barviewaccess',
      component: BarviewAccess
    },
    {
      path: '/messages',
      name: 'messages',
      component: Messages
    },
    {
      path: '/auditlog',
      name: 'auditlog',
      component: Auditlog
    },
    {
      path: '/public/booking/create/:calendarId',
      name: 'publiccreatebooking',
      props: true,
      component: PublicBooking
    },
    {
      path: '/public/booking/cancel/:calendarId/:eventId',
      name: 'publiccancelbooking',
      props: true,
      component: PublicCancel
    }
  ]
})
